import { useEffect, useMemo, useState } from "react";
import SideMenu from "./sideMenu";
import { useSelector } from "react-redux";
import config from "../../config";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MaterialTable from "material-table";
import { Modal } from "react-bootstrap";
import { tableIcons } from "../../tableIcons";
import { TablePagination } from "@material-ui/core";
import { Card, Space, Typography, Button } from "antd";
import CustomTable from "../table";
import CustomTabs from "../tabs";
import LoyaltyPoints from "./LoyaltyPoints";
import { groupBy, sumBy } from "lodash";

const LoyaltyDashboard = (props) => {
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [totalAdded, setTotalAdded] = useState(0);
  const [totalRedeemed, setTotalRedeemed] = useState(0);
  const [totalCustomer, setTotalCustomer] = useState(0);
  const [processedLoyalty, setProcessedLoyalty] = useState([]);
  const [loyaltyDetailsModal, setLoyaltyDetailsModal] = useState(false);
  const [customerLoyalty, setCustomerLoyalty] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loyaltyHistoryDetails, setLoyaltyhistoryDetails] = useState({});
  const [billList, setBillList] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const { productList } = useSelector((state) => state.products);

  const getBillData = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/getCustomerBillDetails`,
        {
          method: "POST",
          body: JSON.stringify({
            phoneNumber: loyaltyHistoryDetails.userPhoneNumber,
            shopId: shopId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "ERROR") return console.log("Err", res.message);
      else {
        if (res !== undefined) {
          if (res.limitExceeds && res.status) {
            try {
              var s3Bills = await fetch(res.data);
              s3Bills = await s3Bills.json();
              const filteredBillData = s3Bills.filter((i) => {
                return i.type === "bill";
              });
              setBillList(filteredBillData);

              return;
            } catch (err) {
              return;
            }
          }
          const filteredBillData = res.data.filter((i) => {
            return i.type === "bill";
          });
          setBillList(filteredBillData);
        }
      }
    } catch (err) {
      console.log("Err", err);
    }
  };

  useEffect(() => {
    if (shopId === "") return;
    fetchLoyaltyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  useEffect(() => {
    if (shopId === "" && loyaltyHistoryDetails?.userPhoneNumber) return;
    getBillData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, loyaltyHistoryDetails?.userPhoneNumber]);

  console.log("billData", billList);

  const fetchLoyaltyData = async () => {
    if (shopId === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/loyalty`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "getLoyalty",
          shopId: shopId,
        }),
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setLoyaltyData(data.loyaltyData);
      })
      .catch((err) => {
        console.log("Err", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  async function fetchCoupon(shopId) {
    try {
      const response = await fetch(config.newApiGateway + "/loyalty/loyalty", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": config.newApiKey,
        },
        body: JSON.stringify({
          action: "fetchLoyaltyCoupon",
          shopId: shopId,
        }),
      });
      const data = await response.json();

      if (Array.isArray(data)) {
        setCouponList(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  }

  const getLoyaltyCustomerName = async (inData) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          phoneNumber: inData.userPhoneNumber,
          shopId: shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        return {
          ...inData,
          customerName: data.customerName,
        };
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const fetchLoyaltyByCustomers = (details) => {
    Promise.all([
      fetch(`${config.newApiGateway}/loyalty/customerLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopId,
          userPhoneNumber: details.userPhoneNumber,
          action: "fetchLoyaltytbycustomer",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setCustomerLoyalty(data);
        let sortedArr = data.sort((d1, d2) => {
          if (new Date(d1.transactionDate) < new Date(d2.transactionDate))
            return 1;
          if (new Date(d1.transactionDate) > new Date(d2.transactionDate))
            return -1;
          return 0;
        });
        setLoyaltyhistoryDetails(data);
        details.customerSince = sortedArr[sortedArr.length - 1].transactionDate;
        details.previousVisit = sortedArr[0].transactionDate;
        setLoyaltyhistoryDetails(details);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;
    return (
      <TablePagination
        {...tablePaginationProps}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }
  const tableColumns = [
    {
      title: "Name",
      render: (rowData) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {rowData.customerName}
          </span>
        );
      },
    },
    {
      title: "Number",
      dataIndex: "userPhoneNumber",
    },
    {
      title: "Added",
      render: (data) => {
        console.log("dataaddedPoints", data.addedPoints, data);
        return <>{parseFloat(data.addedPoints).toFixed(2)}</>;
      },
    },
    {
      title: "Redeemed",
      render: (data) => {
        return <>{parseFloat(data.pointsRedeemed).toFixed(2)}</>;
      },
    },
    {
      title: "Balance",
      render: (data) => {
        return (
          <>{parseFloat(data.addedPoints - data.pointsRedeemed).toFixed(2)}</>
        );
      },
    },
    {
      render: (data) => {
        return (
          <Button
            type="primary"
            ghost
            onClick={() => {
              setLoyaltyDetailsModal(!loyaltyDetailsModal);
              fetchLoyaltyByCustomers(data);
            }}
          >
            Details
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (shopId) {
      fetchCoupon(shopId);
    }
  }, [shopId]);

  useMemo(() => {
    // let tempCurrentPoints = 0;
    const addedPoints = sumBy(loyaltyData, (i) => {
      if (i.pointsAction === "added") {
        return parseFloat(i.points) || 0;
      }
      return 0;
    });

    const redeemedPoints = sumBy(loyaltyData, (i) => {
      if (i.pointsAction === "redeemed") {
        return parseFloat(i.points) || 0;
      }
      return 0;
    });

    if (loyaltyData.length > 0) {
      const groupByData = groupBy(loyaltyData, "userPhoneNumber");
      const keys = Object.keys(groupByData);
      const result = keys.map((key) => {
        const redeemedPoints = sumBy(groupByData[key], (i) => {
          if (i.pointsAction === "redeemed") {
            return parseFloat(i.points) || 0;
          }
          return 0;
        });
        const addedPoints = sumBy(groupByData[key], (i) => {
          if (i.pointsAction === "added") {
            return parseFloat(i.points) || 0;
          }
          return 0;
        });
        return {
          ...groupByData[key][0],
          pointsRedeemed: redeemedPoints,
          addedPoints,
        };
      });
      return Promise.all(
        result.map(async (data) => {
          const customerData = await getLoyaltyCustomerName(data);
          return {
            ...data,
            ...customerData,
          };
        })
      ).then((data) => {
        setTotalAdded(addedPoints);
        setTotalRedeemed(redeemedPoints);
        setTotalCustomer(result.length);
        setProcessedLoyalty(data);
        return data;
      });
    }
  }, [loyaltyData]);

  const exportHead = ["Name", "Number", "Added", "Redeemed", "Balance"];
  const exportValue = [
    "customerName",
    "userPhoneNumber",
    "addedPoints",
    "pointsRedeemed",
    {
      field: "balance",
      render: (rowData) => {
        return parseFloat(rowData.addedPoints - rowData.pointsRedeemed).toFixed(
          2
        );
      },
    },
  ];

  console.log("customerLoyalty", customerLoyalty);

  return (
    <>
      <div>
        <Card
          bodyStyle={{
            padding: 20,
          }}
          style={{
            marginBottom: 20,
          }}
        >
          <Space
            style={{
              justifyContent: "space-between",
              width: "100%",
            }}
            align="space-between"
            direction="horizontal"
          >
            <Space align="center" direction="vertical">
              <Typography.Title level={5}>Current Points</Typography.Title>
              <Typography.Text type="secondary">
                {(totalAdded - totalRedeemed).toFixed(1)}
              </Typography.Text>
            </Space>
            <Space align="center" direction="vertical">
              <Typography.Title level={5}>Total Points Added</Typography.Title>
              <Typography.Text type="secondary">
                {totalAdded.toFixed(1)}
              </Typography.Text>
            </Space>
            <Space align="center" direction="vertical">
              <Typography.Title level={5}>
                Total Points Redeemed
              </Typography.Title>
              <Typography.Text type="secondary">
                {totalRedeemed.toFixed(1)}
              </Typography.Text>
            </Space>
            <Space align="center" direction="vertical">
              <Typography.Title level={5}>Total Customer</Typography.Title>
              <Typography.Text type="secondary">
                {totalCustomer}
              </Typography.Text>
            </Space>
          </Space>
        </Card>
        <CustomTable
          title={"Loyalty Points"}
          columns={tableColumns}
          data={processedLoyalty}
          loading={loading}
          excelExport={true}
          exportHead={exportHead}
          exportValue={exportValue}
          csvAccessKey="loyaltyCsvExport"
        />

        {/* <div className="loyaltyOverview">
          <div className="loyaltyCard">
            <h5>Current Points:</h5>
            <h4>{(totalAdded - totalRedeemed).toFixed(1)}</h4>
          </div>
          <div className="loyaltyCard">
            <h5>Total Points Added:</h5>
            <h4>{totalAdded.toFixed(1)}</h4>
          </div>
          <div className="loyaltyCard">
            <h5>Total Points Reedemed:</h5>
            <h4>{totalRedeemed.toFixed(1)}</h4>
          </div>
          <div className="loyaltyCard">
            <h5>Total Customer:</h5>
            <h4>{totalCustomer}</h4>
          </div>
        </div> */}
        {/* <div>
          <MaterialTable
            columns={[
              {
                title: "Name",
                field: "userName",
                render: (rowData) => {
                  return <span>{rowData.userName}</span>;
                },
              },
              {
                title: "Number",
                field: "userPhoneNumber",
              },
              {
                title: "Added",
                field: "addedPoints",
              },
              {
                title: "Redeemed",
                field: "pointsRedeemed",
              },
              {
                title: "Balance",
                render: (data) => {
                  return (
                    <>
                      {parseFloat(
                        data.addedPoints - data.pointsRedeemed
                      ).toFixed(1)}
                    </>
                  );
                },
              },
              {
                render: (data) => {
                  return (
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        setLoyaltyDetailsModal(!loyaltyDetailsModal);
                        fetchLoyaltyByCustomers(data);
                      }}
                    >
                      Details
                    </Button>
                  );
                },
              },
            ]}
            icons={tableIcons}
            title="Loyalty Details"
            style={{
              margin: "20px",
            }}
            data={processedLoyalty}
            components={{
              Pagination: PatchedPagination,
            }}
          />
        </div> */}
      </div>
      <Modal
        show={loyaltyDetailsModal}
        onHide={() => setLoyaltyDetailsModal(!loyaltyDetailsModal)}
        dialogClassName="loyaltyDetailsModal"
      >
        <Modal.Header>
          <h3>Loyalty History</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="loyaltyOverview">
            <div className="loyaltyCard">
              <h5>Total Points:</h5>
              <h4>
                {(
                  parseFloat(loyaltyHistoryDetails.addedPoints) -
                  parseFloat(loyaltyHistoryDetails.pointsRedeemed)
                ).toFixed(1)}
              </h4>
            </div>
            <div className="loyaltyCard">
              <h5>Name:</h5>
              <h4>{loyaltyHistoryDetails.customerName}</h4>
            </div>
            <div className="loyaltyCard">
              <h5>Phone Number:</h5>
              <h4>{loyaltyHistoryDetails.userPhoneNumber}</h4>
            </div>
            <div className="loyaltyCard">
              <h5>Customer Since:</h5>
              <h4>{loyaltyHistoryDetails.customerSince}</h4>
            </div>
            <div className="loyaltyCard">
              <h5>Previous Visit:</h5>
              <h4>{loyaltyHistoryDetails.previousVisit}</h4>
            </div>
            <div className="loyaltyCard">
              <h5>Total Points Redeemed:</h5>
              <h4>{loyaltyHistoryDetails.pointsRedeemed}</h4>
            </div>
            <div className="loyaltyCard">
              <h5>Overall Points:</h5>
              <h4>{loyaltyHistoryDetails.addedPoints}</h4>
            </div>
          </div>
          <MaterialTable
            columns={[
              {
                title: "Points",
                field: "points",
              },
              {
                title: "Invoice No",

                render: (rowData) => {
                  const bill = billList.find(
                    (bill) =>
                      bill.loyaltyTransactionId === rowData.transactionId
                  );

                  return (
                    <span>
                      {typeof bill !== "undefined"
                        ? bill?.invoicePrefix + bill?.invoiceNumber
                        : "-"}
                    </span>
                  );
                },
              },
              {
                title: "Type",

                render: (rowData) => {
                  const redeemedCouponId = couponList?.find(
                    (c) => c.couponId === rowData.redeemedCouponId
                  );
                  const billData = billList?.find(
                    (b) => b.billId === rowData?.billId
                  );

                  let product = {};
                  if (billData?.loyalty?.rewardType.name === "product") {
                    product = productList?.find(
                      (p) =>
                        p.productId === billData?.loyalty?.rewardType?.value
                    );
                  }

                  return (
                    <>
                      <span>{rowData.pointsAction}</span>
                      {rowData.pointsAction === "redeemed" && (
                        <span>
                          <br />
                          {Object.keys(billData?.loyalty || {}).length > 0 && (
                            <>
                              <b>Coupon Name:</b>
                              <span>{billData?.loyalty?.couponDetails}</span>
                              <br />
                              <b>Coupon Reward:</b>
                              <span
                                style={{
                                  textTransform: "capitalize",
                                }}
                              >
                                {billData?.loyalty?.rewardType.name}
                              </span>
                              <br />
                              {billData?.loyalty?.rewardType.name === "product"
                                ? product?.productName
                                : billData?.loyalty?.rewardType.value}{" "}
                              {!redeemedCouponId && (
                                <span style={{ color: "red" }}>
                                  (Coupon deleted)
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      )}
                    </>
                  );
                },
              },
              {
                title: "Date",
                field: "transactionDate",
              },
            ]}
            icons={tableIcons}
            data={customerLoyalty}
            title="Points History"
            components={{
              Pagination: PatchedPagination,
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            onClick={() => setLoyaltyDetailsModal(!loyaltyDetailsModal)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoyaltyDashboard;
